import {
  BodyText,
  Button,
  CardInteraction,
  DetailText,
  Flex,
  Heading,
  Modal,
  ModalContent,
  ModalRoot,
  ModalTrigger,
  ToggleButtonCard,
  ToggleGroup,
} from '@utilitywarehouse/hearth-react';
import { InfoSmallIcon } from '@utilitywarehouse/hearth-react-icons';

import { BreakdownItem } from '@components/BreakdownItem';
import { useSyncState } from '@hooks/useSyncState';
import { formatCurrency } from '@utils/format';

import { UpgradeWiFiProps } from '../types';
import './styles.scss';

const DetailBreakdown = () => (
  <Modal loading={false} heading="Whole Home Wi-Fi with Amazon eero">
    <ModalContent>
      <BodyText>
        Amazon eero devices are like additional routers you can plug in around
        your home, giving you strong Wi-Fi in every room.
      </BodyText>
      <ul className="wifi-tile__breakdown-list">
        <BreakdownItem>
          £2.50 a month per eero device, worth £100 each
        </BreakdownItem>
        <BreakdownItem>
          Easy to set up and control using the eero app
        </BreakdownItem>
        <BreakdownItem>
          Includes eero secure, with parental controls for specific devices and
          ad blocking for your whole home - worth £25 a year
        </BreakdownItem>
      </ul>
    </ModalContent>
  </Modal>
);

const WiFiTile = ({ price, isSelected, onSelect }: UpgradeWiFiProps) => {
  const [breakdownOpen, setBreakdownOpen] = useSyncState(
    'bb-wifi-breakdown',
    false
  );

  return (
    <ModalRoot
      open={breakdownOpen}
      onOpenChange={(open: boolean) => setBreakdownOpen(open)}
    >
      <ToggleGroup
        type="single"
        onValueChange={() => onSelect(!isSelected)}
        value={isSelected ? 'wifiUpgrade' : ''}
      >
        <ToggleButtonCard
          value="wifiUpgrade"
          label="Add Wi-Fi upgrade"
          aria-labelledby="wholeHomeWifiLabel"
          aria-describedby="wholeHomeWifiDescription"
          alignItems="start"
          data-testid="broadband-wifi-upgrade-selection"
        >
          <Flex direction="column" spacing="lg">
            <Flex
              direction={{ mobile: 'column', tablet: 'row' }}
              asChild
              spacing="lg"
              alignItems={{ mobile: 'start', tablet: 'center' }}
            >
              <header>
                <Flex
                  borderRadius="md"
                  borderWidth="1"
                  borderColor="strong"
                  spacing="lg"
                  alignSelf="center"
                  alignItems="center"
                  justifyContent="center"
                  className="wifi-tile__Graphic"
                >
                  <picture>
                    <source
                      srcSet="https://media.ffycdn.net/eu/utility-warehouse/d/914ba743adfc4b2697bf496ac51687c6?auto=webp&format=png"
                      media="(min-resolution: 150dpi)"
                    />
                    <img
                      src="https://media.ffycdn.net/eu/utility-warehouse/d/914ba743adfc4b2697bf496ac51687c6?auto=webp&format=png&width=140&height=140"
                      alt=""
                    />
                  </picture>
                </Flex>

                <Flex direction="column" spacing="lg">
                  <Heading as="h3" size="md" id="wholeHomeWifiLabel">
                    Whole Home Wi-Fi with Amazon eero
                  </Heading>
                  <Flex gap="100" alignItems="baseline">
                    <DetailText size="3xl" as="span">
                      {formatCurrency(price)}
                    </DetailText>
                    <BodyText as="span">a month</BodyText>
                  </Flex>
                </Flex>
              </header>
            </Flex>
            <BodyText color="secondary" id="wholeHomeWifiDescription">
              Get stronger Wi-Fi around your home with two Amazon eero devices.
              If you need more, you can add them after you sign up.
            </BodyText>
            <CardInteraction secondary>
              <ModalTrigger>
                <Button variant="ghost" size="sm" paddingNone>
                  <InfoSmallIcon /> More details
                </Button>
              </ModalTrigger>
            </CardInteraction>
          </Flex>
        </ToggleButtonCard>
      </ToggleGroup>
      <DetailBreakdown />
    </ModalRoot>
  );
};

export { WiFiTile };
